module.exports = __webpack_public_path__ + "img/icon-left.4cf88c95.png";